import React, { lazy, Suspense, useEffect } from "react";
import { Switch, BrowserRouter as Router, Route } from "react-router-dom";

// Component
import ErrorBoundary from "ErrorBoundary";
import ViewportRestrict from "helper/component/viewport";
import Loader from "helper/component/loader";
import NotFound from "helper/component/404";
import LoadingScreen from "helper/component/loadingscreen";
import { componentLoader, preload } from "helper";
import { preloadData } from "helper/preload";
import { Modals } from "partials/Modal";
import { Toast } from "partials/Toast";

// REDUX
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as mainActions from "redux/actions/main";
import { set_token } from "redux/actions/auth";

// Pages
const Home = lazy(() => componentLoader(() => import("pages/Home")));
const Share = lazy(() => componentLoader(() => import("pages/Share")));

export const Main = (props) => {
  const dispatch = useDispatch();
  const pathname = window.location.pathname.split("/")[1];

  useEffect(() => {
    preload(preloadData);
    if (pathname !== "share") {
      dispatch(set_token());
    }
  }, [dispatch, pathname]);

  return (
    <Router basename={"/"} hashType={"noslash"}>
      <div id="Main" className="main-panel">
        <ErrorBoundary>
          <Suspense fallback={<LoadingScreen />}>
            <ViewportRestrict display={pathname !== "share"} type="portrait" />
            <Loader loader={props?.main?.loader} />
            <Modals />
            <Toast />
            <div className="content-container">
              <Switch>
                <Route exact path="/" component={Home} />
                <Route exact path="/share/:code" component={Share} />
                <Route component={NotFound} />
              </Switch>
            </div>
          </Suspense>
        </ErrorBoundary>
      </div>
    </Router>
  );
};

const mapStateToProps = (state) => ({
  main: state.main,
});

const mapDispatchToProps = (dispatch) => ({
  actionsMain: bindActionCreators(mainActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
